<template>
    <div class="extAttrList">
        <!-- 业务参数设置 -->
        <el-card class="box-card">
            <div slot="header" class="clearfix header">
                <span class="card-header">扩展属性</span>
            </div>
            <el-row>
                <el-col :span="21">
                    <el-form :label-position="labelPosition" label-width="80px" :model="extendForm">
                        <el-form-item label="扩展表：" style="width: 30%;margin-right: 30px;" class="fl" prop="extend_sheet">
                            <el-select v-model="extendForm.extend_sheet" placeholder="请选择扩展内容" style="width: 100%;">
                                <el-option :label="item.product_type" :value="item.categorya_id" v-for="(item,index) in contractLists" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="扩展中文名：" style="width: 30%;margin-right: 30px;" class="fl" prop="extend_name">
                            <el-input v-model.trim="extendForm.extend_name"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="3" class="fr" style="margin-top: 50px;">
                    <el-button type="danger" size="medium" @click="clearForm()">重置</el-button>
                    <el-button type="success" size="medium" @click="queryFrom()" style="margin-left: 0px;">查询</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix header">
                <span class="card-header">扩展信息</span>
                <el-button class="fr" size="mini" type="success" @click="handleAddForm()">新增</el-button>
            </div>
            <!--列表-->
            <el-table :data="extendInfo" highlight-current-row border style="width: 100%;" :header-cell-style="{'text-align':'center'}">
                <el-table-column prop="extend_sheet_name" label="扩展表名" width="200" align="center" sortable></el-table-column>
                <el-table-column prop="attr_english" label="属性英文名" width="200" align="center" sortable></el-table-column>
                <el-table-column prop="attr_chinese" label="属性中文名" width="200" align="center" sortable></el-table-column>
                <el-table-column prop="attr_type" label="属性类型" width="200" align="center" sortable></el-table-column>
                <el-table-column label="操作" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-dropdown  trigger="click">
                            <el-button type="success" size="mini">
                              请选择<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-button v-if="dialogStatus=='create'" type="success" @click.native="createData">添加</el-button>
                                <el-button v-else type="success" @click.native="updateData()">保存</el-button>
                                <el-dropdown-item><span @click="handleDel(scope.$index, scope.row)">删除</span></el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination 
                    layout="prev, pager, next" 
                    @current-change="handleCurrentChange" 
                    :page-size="20" :total="total" style="float:right;">
                </el-pagination>
            </el-col>
            <!--修改界面 parameter_number-->
            <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogParameterFormVisible" :close-on-click-modal="false">
                <el-form :label-position="labelPosition" :model="editParameterForm" label-width="100px" :rules="editParameterFormRules" ref="editParameterForm">
                    <el-row>
                        <el-form-item label="参数类型：" prop="name" style="width: 40%;" class="fl">
                            <el-input v-model.trim="editParameterForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="参数编码：" prop="data_sheet" style="width: 55%;" class="fr">
                            <el-input v-model.trim="editParameterForm.data_sheet"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="参数数值：" prop="name" style="width: 40%;" class="fl">
                            <el-input v-model.trim="editParameterForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="参数名称：" prop="data_sheet" style="width: 55%;" class="fr">
                            <el-input v-model.trim="editParameterForm.data_sheet"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="参数所属模块：" prop="remarks">
                        <el-input type="text" v-model.trim="editParameterForm.remarks"></el-input>
                    </el-form-item>
                    <el-form-item label="参数备注:" prop="remarks">
                        <el-input type="textarea" v-model.trim="editParameterForm.remarks"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateData">保存</el-button>
                    <el-button @click.native="dialogParameterFormVisible=false">取消</el-button>
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
    export default {
        name: 'extAttrList',
        data () {
            return {
                dialogStatus: "",
                textMap: {
                    update: "修改信息",
                    create: "新增信息"
                },
                labelPosition:'left',
                extendForm: {
                    extend_sheet: '',
                    extend_name: '',
                },
                contractLists:[
                    {
                        categorya_id: 1, 
                        product_type: "平板状建筑材料及制品,管状绝热材料"
                    },
                    {
                        categorya_id: 2, 
                        product_type: "电线电缆套管"
                    },
                    {
                        categorya_id: 3, 
                        product_type: "铺地材料"
                    },
                    {
                        categorya_id: 4, 
                        product_type: "窗帘幕布,家具制品装饰用织物"
                    },
                    {
                        categorya_id: 5, 
                        product_type: "电器,家具制品用泡沫塑料"
                    },
                    {
                        categorya_id: 6, 
                        product_type: "饰面型防火涂料"
                    }
                ],
                dialogStatus: "",
                dialogParameterFormVisible: false,
                extendInfo: [
                    {
                        extend_sheet_name: 'heihihidldkd',
                        attr_english: '11111111',
                        attr_chinese: 'curry',
                        attr_type:'2323232323'
                    },
                ],
                total: 0,
                page: 1,
                sels: [], //列表选中列
                //编辑界面数据
                editParameterForm: {
                    name: "",
                    data_sheet: '',
                    remarks:''
                },
                editParameterFormRules: {
                    name: [{ required: true, message: "请输入数据名称", trigger: "blur" }],
                    data_sheet: [{ required: true, message: "请输入数据表", trigger: "blur" }],
                },
                addFormVisible: false, //新增界面是否显示
                addFormRules: {
                    name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
                },
                multipleSelection: []
            }
        },
        mounted () {
      
        },
        computed: {},
        methods: {
            //重置
            clearForm:function () {
                this.extendForm.extend_sheet=''
                this.extendForm.extend_name=''
            },
            //查询
            queryFrom:function () {
                console.log(this.extendForm)
            },
            //跳转到第几页
            handleCurrentChange(val) {
                this.page = val;
            },
            //删除
            handleDel: function(index, row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    let para = { id: row.id };
                    removeUser(para).then(res => {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.getUsers();
                    });
                }).catch(() => {});
            },
            //显示编辑界面
            handleEdit: function(index, row) {
                this.dialogStatus = "update";
                this.dialogParameterFormVisible = true;
                //this.editFormVisible = true;
                this.editParameterForm = Object.assign({}, row);
            },
            //编辑
            updateData:function() {
                this.$refs.editParameterForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            let para = Object.assign({}, this.editForm);
                                editUser(para).then(res => {
                                    this.$message({
                                        message: "提交成功",
                                        type: "success"
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.dialogFormVisible = false;
                                    this.getUsers();
                                });
                        }).catch(e => {
                            // 打印一下错误
                            console.log(e);
                        });
                    }
                });
            },
            AddQuery: function() {
                this.dialogStatus = "create";
                this.dialogFormVisible = true
            },
            //新增参数
            handleAddForm() {
                this.dialogParameterFormVisible = true
                this.dialogStatus = "create";
            },
            //新增
            createData: function() {
                this.$refs.editParameterForm.validate(valid => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editForm.id = (parseInt(Math.random() * 100)).toString() // mock a id
                            let para = Object.assign({}, this.editForm);
                            console.log(para);
              
                            para.birth = !para.birth || para.birth == "" ? "" : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
                            addUser(para).then(res => {
                                this.$message({
                                    message: "提交成功",
                                    type: "success"
                                });
                                this.$refs["editForm"].resetFields();
                                this.dialogFormVisible = false;
                                this.getUsers();
                            });
                        }).catch(e => {
                            // 打印一下错误
                            console.log(e);
                        });
                    }
                });
            }
        },
    }
</script>
<style lang="scss" scoped>
    .extAttrList{
        .box-card{
            margin-bottom: 20px;
            border-radius: 0px;
            .card-header{
                font-size: 14px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// extAttrList.vue?f00c8e98